import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { useAuth } from 'context/auth-context';

import IssuedDocumentsPageHeader from './components/IssuedDocumentsPageHeader';
import IssuedDocumentsTable from './components/IssuedDocumentsTable';
import { IssuedDocumentSearchFilters } from './types';

const IssuedDocuments = (): JSX.Element => {
  const initialFilterValues = {
    search: '',
    type: null,
    isArrangeByLastName: false,
    isSigned: null,
  };

  const { hasPerm } = useAuth();
  const documentsPerm = hasPerm('IssuedDocumentMutate');

  const [searchFilters, setSearchFilters] = useState<IssuedDocumentSearchFilters>(initialFilterValues);
  const [debouncedSearchFilters] = useDebouncedValue<IssuedDocumentSearchFilters>(searchFilters, 250);

  return (
    <>
      <IssuedDocumentsPageHeader
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialFilterValues={initialFilterValues}
      />

      <IssuedDocumentsTable searchFilters={debouncedSearchFilters} permission={documentsPerm} />
    </>
  );
};

export default IssuedDocuments;
